import TextareaField from "../../../components/TextareaField";

export default function ObiectStep({ data, errors, update }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <TextareaField
        label="Descrierea serviciilor"
        value={data.obiectContract}
        onChange={update("obiectContract")}
        placeholder="ex: Servicii de dezvoltare software, consultanta IT, design grafic, contabilitate, marketing digital"
        required
        error={errors.obiectContract}
        rows={5}
      />
    </div>
  );
}
